import {useEffect} from "react";
import FadeInSection from "./FadeInSection";
import './styles.css';
import aphoto from '../images/AndrewPfp.jpg';
import kphoto from '../images/StockImageEmpty.jpg'

function MeetPage( {sectionTwoRef} ) {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div id={"MeetPage"} ref={sectionTwoRef}>
            <FadeInSection>
                <div className={"pInfoDiv overfull"} >
                    <div className={"pInfoText"}>
                        <h4>Andrew Williams</h4>
                        <h5>Attorney At Law</h5>
                        <h6 style={{margin: '30px 20px 30px 0'}}>
                            Andrew S. Williams has 25 years of legal experience representing clients in Personal Injury
                            claims. Andrew provides his clients with personal attention and always works to maximize the
                            amount of recovery for the client as well as the speed of resolution.
                        </h6>

                        <div className={'eduInfoContainer'}>
                            <div>
                                <h5>Education</h5>
                                <ul>
                                    <li><h6>J.D., The Catholic University of America (1999)</h6></li>
                                    <li><h6>B.A., The Pennsylvania State University (1996)</h6></li>
                                </ul>


                            </div>
                            <div>
                                <h5 style={{marginBottom: '15px'}}>Bar Admissions</h5>
                                <h6>Maryland, D.C., Admitted to practice in: </h6>
                                <ul style={{margin: '0'}}>
                                    <li><h6>The United States District Court of Maryland</h6></li>
                                    <li><h6>The United States District Court for the District of Columbia</h6></li>
                                </ul>
                            </div>
                        </div>
                        <div className={'eduInfoContainer'}>
                            <div>
                                <h5>Memberships</h5>
                                <ul>
                                    <li><h6>Maryland State Bar Association</h6></li>
                                    <li><h6>District of Columbia Bar</h6></li>
                                    <li><h6>Prince George's County Bar Associations</h6></li>
                                </ul>
                            </div>
                        </div>
                        <a className={'emailButtonMeet'} href={'mailto:Andrew@williamslawgroup.com'}>Email Andrew</a>
                    </div>
                    <img className={"headshot"} src={aphoto} alt={"Andrew Williams"}/>
                </div>
            </FadeInSection>

            <FadeInSection>
                <div className={"pInfoDiv overfull"} style={{paddingTop: '50px'}}>
                    <img className={"headshot"} src={kphoto} alt={"Kevin Williams"}/>
                    <div className={"pInfoText"} id={"KpInfoText"}>
                        <h4>Kevin Williams</h4>
                        <h5>Attorney At Law</h5>
                        <h6 style={{margin: '30px 20px 30px 0'}}>
                            J. Kevin Williams is a dedicated and results-driven attorney with over 22 years of legal
                            experience representing clients in Personal Injury claims. Known for a strategic mindset and
                            unwavering commitment to client advocacy, he has built a reputation for integrity, clarity,
                            and successful outcomes inside and outside the courtroom.
                        </h6>

                        <div className={'eduInfoContainer'}>
                            <div>
                                <h5>Education</h5>
                                <ul>
                                    <li><h6>J.D., The Catholic University of America (2004)</h6></li>
                                    <li><h6>B.A., University of Georgia (2001)</h6></li>
                                </ul>


                            </div>
                            <div>
                                <h5 style={{marginBottom: '15px'}}>Bar Admissions</h5>
                                <h6>Maryland, D.C., Admitted to practice in: </h6>
                                <ul style={{margin: '0'}}>
                                    <li><h6>The United States District Court of Maryland</h6></li>
                                    <li><h6>The United States District Court for the District of Columbia</h6></li>
                                </ul>
                            </div>
                        </div>
                        <div className={'eduInfoContainer'}>
                            <div>
                                <h5>Memberships</h5>
                                <ul>
                                    <li><h6>Maryland State Bar Association</h6></li>
                                    <li><h6>District of Columbia Bar</h6></li>
                                    <li><h6>Prince George's County Bar Associations</h6></li>
                                </ul>
                            </div>
                        </div>
                        <a className={'emailButtonMeet'} href={'mailto:Kevin@williamslawgroup.com'}>Email Kevin</a>
                    </div>
                </div>
            </FadeInSection>

        </div>
    );
}

// <br/><br/>
// If you're seeking experienced legal representation backed by compassion, precision, and
// results, contact J. Kevin Williams today.
export default MeetPage;
